<template>
    <div class="third-icons">
        <tile-question-layout v-if="panel_required" :modifier_class="'_3-col'" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareSuiteSelector from "../DesignerQuestionHardwareSuiteSelector.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareSuiteSelector,
            TileQuestion,
        ],
        props: {
            suites: {
                default(){
                    return '58,8,5,76';
                }
            },
            collection: {
                required: false,
                default() {
                    return '';
                }
            }
        },
        computed: {
            panel_required() {
                return this.filtered_option_list.length > 1;
            }
        }
    }
</script>
